import colors from "../colors.js";

export default colors("4269d0efb118ff725c6cc5b03ca951ff8ab7a463f297bbf59c6b4e9498a0");



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale-chromatic/src/categorical/observable10.js
// module id = 613
// module chunks = 0